import { Link } from "react-router-dom";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { XCircle } from "lucide-react";

export default function BillingCancel() {
  return (
    <div className="min-h-[70vh] flex items-center justify-center" data-testid="billing-cancel">
      <Card className="p-10 max-w-md w-full text-center" style={{ background: "var(--surface)", borderColor: "var(--border)" }}>
        <XCircle className="w-14 h-14 mx-auto text-slate-400" />
        <h2 className="display text-2xl mt-4">Checkout cancelled</h2>
        <p className="text-sm mt-2" style={{ color: "var(--text-soft)" }}>No charges made. You can pick a plan whenever you're ready.</p>
        <div className="flex gap-3 mt-6 justify-center">
          <Button asChild style={{ background: "var(--brand)" }}><Link to="/billing">Back to plans</Link></Button>
          <Button asChild variant="outline"><Link to="/">Dashboard</Link></Button>
        </div>
      </Card>
    </div>
  );
}
